import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

const DefaultFallback = () => (
    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
    </Box>
);

/**
 * Feature-level i18n boundary: waits until all given namespaces are loaded,
 * then renders children. Use at route/feature roots so descendants can call t()
 * without raw-key flicker and without per-component Suspense opt-in.
 *
 * @param {string|string[]} ns - One namespace or a list; `ready` is true only when all are loaded.
 */
const I18nNamespaceGate = ({ ns, children, fallback = <DefaultFallback /> }) => {
    const { ready } = useTranslation(ns, { useSuspense: false });
    if (!ready) {
        return fallback;
    }
    return children;
};

export default I18nNamespaceGate;
